module.exports = __webpack_public_path__ + "static/media/gradepro-logo.38f3a1ff.svg";